import { useState, useEffect } from 'react'

/**
 * useWindowSize in hook way
 *
 * @export
 * @param {} windowSize
 * @returns @string
 */

function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined
    })
    useEffect(() => {
        let isMounted = true
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            })
        }
        if (isMounted) {
            window.addEventListener('resize', handleResize)
            handleResize()
        }

        return () => {
            isMounted = false
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    const userAgent = navigator.userAgent.toLowerCase()
    return {
        width: windowSize.width,
        height: windowSize.height,
        isAndroidOs: userAgent.indexOf('android') > -1,
        isIosOs: userAgent.indexOf('iphone') > -1,
        isPcDevice: userAgent.indexOf('android') === -1 && userAgent.indexOf('iphone') === -1
    }
}

export default useWindowSize
